export default __webpack_public_path__ + "static/media/subLogo.fe652e53.png";